import { Injectable, inject, signal } from '@angular/core';
import { AuthOtpService } from '../../auth/auth-otp.service';
  import { finalize } from 'rxjs/operators';

type Step = 'closed' | 'start' | 'otp';

@Injectable({ providedIn: 'root' })
export class InvestmentFlowService {
  private authOtp = inject(AuthOtpService);

  step = signal<Step>('closed');
  phone = signal<string | null>(null);
  loading = signal(false);
  error = signal<string | null>(null);
  transactionReqId = signal<string | null>(null);


  openStart() {
    this.error.set(null);
    this.step.set('start');
  }


requestOtpAndOpen(
  phone: string,
  options?: { onFinally?: () => void }
): void {
  this.loading.set(true);
  this.error.set(null);
  this.phone.set(phone);

  this.authOtp.requestOtp(phone)
    .pipe(
      finalize(() => {
        this.loading.set(false);
        options?.onFinally?.();
      })
    )
    .subscribe({
      next: (res) => {
        console.log(res);
        this.transactionReqId.set(res.transaction_req_id);
        this.step.set('otp');
      },
      error: (err) => {
        this.error.set(err?.error?.error ?? 'فشل إرسال رمز التحقق');
      }
    });
}

verifyOtp(otp: string, onSuccess: (isNew: boolean) => void) {
  const phone = this.phone();
  const reqId = this.transactionReqId();

  if (!phone || !reqId) {
    this.error.set('انتهت جلسة التحقق');
    return;
  }

  this.loading.set(true);
  this.error.set(null);

  this.authOtp.verifyOtp(phone, otp, reqId).subscribe({
    next: (res) => {
      console.log(res);

      this.authOtp.saveAccessFromVerifyResponse(res);

      this.loading.set(false);
      onSuccess(res.user.is_new_user);
    },
    error: (err) => {
      this.loading.set(false);
      this.error.set(err?.error?.error ?? 'رمز التحقق غير صحيح');
    }
  });
}


  close() {
    this.step.set('closed');
    this.phone.set(null);
    this.transactionReqId.set(null);
    this.error.set(null);
    this.loading.set(false);
  }
}
